export default {"src":"/_next/static/media/nex-logo.2f9d6e6f.svg","height":27,"width":99,"blurWidth":0,"blurHeight":0};